<template>
  <div class="language-switch">
    <n-select
      v-model:value="language"
      :placeholder="t('app.language.index')"
      :options="availableLocales"
    ></n-select>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { NSelect } from 'naive-ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const i18n = useI18n()

const language = ref(i18n.locale)
const availableLocales = computed(() => [
  { label: t('app.language.zhs'), value: 'zhs' },
  { label: t('app.language.zht'), value: 'zht' },
  { label: t('app.language.nl'), value: 'nl' },
  {
    label:
      language.value === 'en'
        ? t('app.language.en')
        : `${t('app.language.en')} (English)`,
    value: 'en',
  },
  { label: t('app.language.fr'), value: 'fr' },
  { label: t('app.language.de'), value: 'de' },
  { label: t('app.language.it'), value: 'it' },
  { label: t('app.language.ja'), value: 'ja' },
  { label: t('app.language.pt'), value: 'pt' },
  { label: t('app.language.ptb'), value: 'ptb' },
  { label: t('app.language.es'), value: 'es' },
])
</script>

<style lang="scss" scoped>
.language-switch {
  width: 192px;
}
</style>
